<template>
  <div>
    <el-dialog
      id="editDialog"
      :title="orderId ? '修改销售单' : '新增销售单'"
      :visible="true"
      @close="close(false)"
      width="1000px"
    >
      <el-form
        :model="headInfo"
        label-position="right"
        label-width="110px"
        ref="editOrderFormRef"
        :rules="{
          orderDate: this.$ruleUtil.simple({
            fieldName: '单据日期',
            handleType: '选择',
            required: true,
          }),
          customerId: this.$ruleUtil.simple({
            fieldName: '客户',
            handleType: '选择',
            required: true,
          }),
          customerName: this.$ruleUtil.simple({
            fieldName: '联系人姓名',
            required: true,
            max: 50,
          }),
          customerPhoneNumber: this.$ruleUtil.simple({
            fieldName: '联系方式',
            required: true,
            max: 20,
          }),
          customerAddress: this.$ruleUtil.simple({
            fieldName: '联系地址',
            required: true,
            max: 200,
          }),
          collectVoucherSysFileIdList: this.$ruleUtil.array(
            '收款凭证',
            '上传',
            orderConfig.collectVoucherRequired ? 1 : 0,
            10
          ),
          collectRemark: this.$ruleUtil.simple({
            fieldName: '收款备注',
            required: false,
            max: 200,
          }),
          paperOrderSysFileIdList: this.$ruleUtil.array(
            '纸质单据',
            '上传',
            orderConfig.paperOrderRequired ? 1 : 0,
            10
          ),
          totalQuantity: this.$ruleUtil.number(
            '所选商品数量',
            this.quantityMinLimit
          ),
        }"
        v-if="headInfo"
      >
        <el-form-item label="单号" v-if="headInfo.id">
          <span v-fmtype="headInfo.orderNo ? null : 'info'">{{
            headInfo.orderNo || "草稿"
          }}</span>
        </el-form-item>
        <el-form-item label="单据日期" prop="orderDate">
          <el-date-picker
            v-model="headInfo.orderDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择单据日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="客户" prop="customerId">
          <CustomerSelect
            :value="customer"
            @select="selectCustomer"
          ></CustomerSelect>
        </el-form-item>
        <el-row :gutter="10" v-if="headInfo.customerId">
          <el-col :span="6">
            <el-form-item label="联系人信息" prop="customerId">
              <el-input
                v-model="headInfo.customerName"
                placeholder="请输入联系人姓名"
                :disabled="!orderConfig.editCustomer"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width="10" prop="customerId">
              <el-input
                v-model="headInfo.customerPhoneNumber"
                placeholder="请输入联系方式"
                :disabled="!orderConfig.editCustomer"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label-width="10" prop="customerId">
              <el-input
                v-model="headInfo.customerAddress"
                placeholder="请输入联系地址"
                :disabled="!orderConfig.editCustomer"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="所选商品" prop="totalQuantity">
          <div class="fm-flex">
            <p
              v-fmtype="'success'"
              v-if="headInfo.totalQuantity && headInfo.totalQuantity > 0"
            >
              {{ "共 " + headInfo.totalQuantity + " 件商品" }}
            </p>
            <span v-fmtype="'error'" v-else>未选择商品</span>
            <span>，总零售价：</span>
            <FmAmount :amount="headInfo.commodityBuyingTotalAmount"></FmAmount>
            <el-button
              class="fm-ml-15"
              type="primary"
              plain
              size="mini"
              icon="el-icon-plus"
              @click="showSelectCommodityDialog"
              >选择商品</el-button
            >
          </div>
        </el-form-item>
        <el-table
          :data="itemList || []"
          stripe
          :row-key="
            (row) => {
              return row.itemNo + row.commoditySpecId;
            }
          "
          max-height="500px"
          style="width: 100%"
        >
          <el-table-column
            label="商品图片"
            width="100"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <CommodityImage
                size="60px"
                :commodity="scope.row.commodity"
                :commoditySpec="scope.row.commoditySpec"
              ></CommodityImage>
            </template>
          </el-table-column>
          <el-table-column
            prop="commodityName"
            label="商品信息"
            min-width="250"
            align="left"
            header-align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div style="line-height: 1.4em">
                <div style="font-size: 1.1em">
                  {{ scope.row.commodity.name }}
                </div>
                <div class="fm-mt-5">
                  {{ "分类：" + scope.row.commodity.commodityCategory.name }}
                </div>
                <div>{{ "单位：" + scope.row.commodity.unit }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="commoditySpec.specName"
            label="规格名称"
            min-width="180"
            align="left"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" placement="top-start">
                <div slot="content" style="max-width: 300px">
                  {{ scope.row.commoditySpec.specName }}
                </div>
                <span class="fm-line-3">{{
                  scope.row.commoditySpec.specName
                }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="buyingPrice"
            label="规格零售价"
            width="180"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-input-number
                style="width: 170px"
                v-model="scope.row.buyingPrice"
                size="small"
                :precision="2"
                :min="0"
                :step="1"
                @change="changeItemPrice(scope.$index, scope.row)"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            prop="itemQuantity"
            label="购买数量"
            width="150"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <FmNumberDigitBox
                :key="
                  'itemQuantityInputNumber' + scope.$index + itemQuantityKey
                "
                :value="scope.row.itemQuantity"
                size="small"
                :min="0"
                :max="
                  scope.row.commoditySpec &&
                  !scope.row.commoditySpec.inProduction
                    ? scope.row.commoditySpec.availableQuantity
                    : 2147483647
                "
                :step="1"
                @change="
                  (e) => {
                    changeItemQuantity(scope.$index, scope.row, e);
                  }
                "
              ></FmNumberDigitBox>
            </template>
          </el-table-column>
          <el-table-column
            prop="commodityBuyingTotalAmount"
            label="总零售价"
            width="120"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <FmAmount
                :amount="scope.row.commodityBuyingTotalAmount"
              ></FmAmount>
            </template>
          </el-table-column>
          <el-table-column
            prop="disCountAmount"
            label="折扣金额"
            width="120"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <FmAmount :amount="scope.row.disCountAmount"></FmAmount>
            </template>
          </el-table-column>
          <el-table-column
            prop="itemAmount"
            label="成交价"
            width="200"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-input-number
                style="width: 170px"
                v-model="scope.row.itemAmount"
                size="small"
                :precision="2"
                :min="0"
                :max="
                  typeof scope.row.commodityBuyingTotalAmount == 'string'
                    ? Number(scope.row.commodityBuyingTotalAmount)
                    : scope.row.commodityBuyingTotalAmount
                "
                :step="1"
                @change="changeItemAmount(scope.$index, scope.row)"
              ></el-input-number>
            </template>
          </el-table-column>
        </el-table>
        <el-form-item label="优惠金额" prop="disCountAmount" class="fm-mt-10">
          <FmAmount
            style="line-height: unset"
            :amount="headInfo.disCountAmount"
          ></FmAmount>
        </el-form-item>
        <el-form-item label="商品零售成交价" prop="commodityBuyingAmount">
          <el-input-number
            v-model="headInfo.commodityBuyingAmount"
            size="small"
            :precision="2"
            :min="0"
            :max="maxCommodityBuyingAmount"
            :step="1"
            style="width: 180px"
            @change="changeCommodityBuyingAmount"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          label="收款凭证"
          class="fm-mt-10"
          prop="collectVoucherSysFileIdList"
        >
          <div
            class="fm-rela UploadImage"
            v-for="(file, index) in collectVoucherFileList"
            :key="index"
          >
            <el-image
              :id="'collectVoucherImage' + index"
              class="UploadImage"
              :src="file.url"
              :preview-src-list="collectVoucherFileList.map((d) => d.url)"
              :initial-index="index"
              alt=""
            />
            <div
              class="UploadImageLoadingIcon fm-center"
              v-if="file.status == 'ready'"
            >
              <i
                class="UploadImageLoadingIcon-icon el-icon el-icon-loading"
              ></i>
            </div>
            <div class="UploadImageHandleIcon">
              <i
                @click="collectVoucherFilePreview(index)"
                alt="预览图片"
                class="UploadImageHandleIcon-icon fm-center UploadImageHandleIcon-previewIcon el-icon el-icon-view"
              ></i>
              <i
                alt="删除图片"
                @click="collectVoucherFileDelete(index, file)"
                class="UploadImageHandleIcon-icon fm-center UploadImageHandleIcon-deleteIcon el-icon el-icon-delete"
              ></i>
            </div>
          </div>
          <el-upload
            :action="$envConfig.VUE_APP_uploadSaleOrderCollectVoucher + ''"
            :headers="{
              AuthorityToken: $storageUtil.getAuthorityToken(),
            }"
            :limit="10"
            multiple
            accept="image/*"
            :file-list="collectVoucherFileList"
            :show-file-list="false"
            :on-change="collectVoucherFileChange"
            :on-success="collectVoucherFileSuccess"
            :on-exceed="() => this.$message.warning('最多上传10张图片')"
            v-if="collectVoucherFileList.length < 10"
          >
            <div slot="default" class="fm-center UploadImage">
              <i class="el-icon-plus"></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="收款备注" prop="collectRemark">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            maxlength="200"
            show-word-limit
            v-model="headInfo.collectRemark"
            style="width: 400px"
            placeholder="请输入收款备注信息"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="纸质单据"
          class="fm-mt-10"
          prop="paperOrderSysFileIdList"
        >
          <div
            class="fm-rela UploadImage"
            v-for="(file, index) in paperOrderFileList"
            :key="index"
          >
            <el-image
              :id="'paperOrderImage' + index"
              class="UploadImage"
              :src="file.url"
              :preview-src-list="paperOrderFileList.map((d) => d.url)"
              :initial-index="index"
              alt=""
            />
            <div
              class="UploadImageLoadingIcon fm-center"
              v-if="file.status == 'ready'"
            >
              <i
                class="UploadImageLoadingIcon-icon el-icon el-icon-loading"
              ></i>
            </div>
            <div class="UploadImageHandleIcon">
              <i
                @click="paperOrderFilePreview(index)"
                alt="预览图片"
                class="UploadImageHandleIcon-icon fm-center UploadImageHandleIcon-previewIcon el-icon el-icon-view"
              ></i>
              <i
                alt="删除图片"
                @click="paperOrderFileDelete(index, file)"
                class="UploadImageHandleIcon-icon fm-center UploadImageHandleIcon-deleteIcon el-icon el-icon-delete"
              ></i>
            </div>
          </div>
          <el-upload
            :action="$envConfig.VUE_APP_uploadSaleOrderPaperOrder + ''"
            :headers="{
              AuthorityToken: $storageUtil.getAuthorityToken(),
            }"
            :limit="10"
            multiple
            accept="image/*"
            :file-list="paperOrderFileList"
            :show-file-list="false"
            :on-change="paperOrderFileChange"
            :on-success="paperOrderFileSuccess"
            :on-exceed="() => this.$message.warning('最多上传10张图片')"
            v-if="paperOrderFileList.length < 10"
          >
            <div slot="default" class="fm-center UploadImage">
              <i class="el-icon-plus"></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            maxlength="200"
            show-word-limit
            v-model="headInfo.remark"
            style="width: 400px"
            placeholder="请输入备注信息"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <fm-justify-view>
          <p slot="left">
            单据金额：
            <FmAmount
              bold
              style="line-height: unset"
              :amount="headInfo.orderAmount"
            ></FmAmount>
          </p>
          <div slot="right">
            <el-button @click="close(false)">取 消</el-button>
            <el-button type="primary" @click="edit(false)"> 保存 </el-button>
          </div>
        </fm-justify-view>
      </div>
    </el-dialog>

    <CommoditySelectDialog
      :show="commoditySelectDialogShow"
      from="SaleOrder"
      :selectList="itemList"
      @selectCommodity="selectCommodity"
      @close="commoditySelectDialogShow = false"
      v-if="commoditySelectDialogShow"
    ></CommoditySelectDialog>
  </div>
</template>

<script>
export default {
  name: "Rterpv2WebSaleOrderEditDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: String,
      default: null,
    },
  },
  watch: {
    show: {
      handler(newVal) {
        if (newVal) {
          this.orderConfig = this.$options.data().orderConfig;
          this.itemQuantityKey = this.$options.data().itemQuantityKey;
          this.headInfo = this.$options.data().headInfo;
          this.itemList = this.$options.data().itemList;
          this.customer = this.$options.data().customer;
          this.commoditySelectDialogShow =
            this.$options.data().commoditySelectDialogShow;
          this.collectVoucherFileList =
            this.$options.data().collectVoucherFileList;
          this.paperOrderFileList = this.$options.data().paperOrderFileList;
          setTimeout(() => {
            this.initOrderData();
            this.getOrderConfig();
            this.quantityMinLimit = this.$jsTool.getTenantCommodityMinValue();
          }, 100);
        }
        this.$nextTick(() => {
          this.$refs.editOrderFormRef.clearValidate();
        });
      },
      immediate: true,
    },
    orderId: {
      handler(newVal) {
        if (newVal) {
          setTimeout(() => {
            this.getOrderInfo();
          }, 100);
        }
      },
      immediate: true,
    },
  },
  computed: {
    maxCommodityBuyingAmount() {
      if (!this.itemList || this.itemList.length == 0) {
        return;
      }
      let amount = this.$jsTool.sum(
        this.itemList.map((d) => d.commodityBuyingTotalAmount)
      );
      return Number(amount);
    },
  },
  data() {
    return {
      orderConfig: {
        editCustomer: false,
        collectVoucherRequired: true,
        paperOrderRequired: true,
      },

      itemQuantityKey: "null",

      headInfo: {
        orderDate: null,
        customerId: null,
        customerName: null,
        customerPhoneNumber: null,
        customerAddress: "",
        collectVoucherSysFileIdList: [],
        collectRemark: "",
        paperOrderSysFileIdList: [],
        commodityBuyingTotalAmount: "0.00",
        disCountAmount: "0.00",
        commodityBuyingAmount: "0.00",
        orderAmount: "0.00",
        totalQuantity: 0,
        remark: "",
      },
      itemList: [],
      customer: {},

      commoditySelectDialogShow: false,

      collectVoucherFileList: [],
      paperOrderFileList: [],

      quantityMinLimit: 0.001,

      defaultCustomer: {},
    };
  },

  mounted() {},

  methods: {
    async initOrderData() {
      this.headInfo.orderDate = this.$moment(new Date()).format("yyyy-MM-DD");
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.clearValidate();
      });
      if (!this.orderId) {
        let getCustomerRes = await this.$api.customer_getDefault();
        if (getCustomerRes && getCustomerRes.success) {
          this.defaultCustomer = getCustomerRes.data;
          this.selectCustomer(this.defaultCustomer, "已加载默认客户");
        }
      }
      this.$forceUpdate();
    },
    async getOrderConfig() {
      let res = await this.$api.tenantPersonalConfig_findByCodeIn([
        "Order:SaleOrder:EditCustomer",
        "Order:SaleOrder:PaperOrderRequired",
        "Order:SaleOrder:CollectVoucherRequired",
      ]);
      if (res && res.success) {
        let editCustomerIndex = res.data.findIndex(
          (d) => d.code == "Order:SaleOrder:EditCustomer"
        );
        if (
          editCustomerIndex > -1 &&
          res.data[editCustomerIndex].value == "true"
        ) {
          this.orderConfig.editCustomer = true;
        }
        let collectVoucherIndex = res.data.findIndex(
          (d) => d.code == "Order:SaleOrder:CollectVoucherRequired"
        );
        if (
          collectVoucherIndex > -1 &&
          res.data[collectVoucherIndex].value == "false"
        ) {
          this.orderConfig.collectVoucherRequired = false;
        }
        let paperOrderIndex = res.data.findIndex(
          (d) => d.code == "Order:SaleOrder:PaperOrderRequired"
        );
        if (
          paperOrderIndex > -1 &&
          res.data[paperOrderIndex].value == "false"
        ) {
          this.orderConfig.paperOrderRequired = false;
        }
      }
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.clearValidate();
      });
    },

    selectCustomer(item, message = "已自动更新联系人信息") {
      this.headInfo.customerId = item.id;
      this.headInfo.customerName = item.name;
      this.headInfo.customerPhoneNumber = item.phoneNumber;
      this.headInfo.customerAddress = item.address;
      this.customer = item;
      if (message) {
        this.$message({
          message: message,
          type: "success",
        });
      }
    },
    // 选择商品相关
    showSelectCommodityDialog() {
      this.commoditySelectDialogShow = true;
    },
    selectCommodity(list) {
      list.forEach((item, index) => {
        item.itemNo = index + 1; // 索引从 0 开始，所以 itemNo 从 1 开始
      });
      this.itemList = list;
      // 带销售套装的分组计算，避免重复
      let commodityBuyingAmount = "0.00";
      if (list && list.length > 0) {
        commodityBuyingAmount = this.$jsTool.sum(list.map((d) => d.itemAmount));
      }
      this.headInfo.commodityBuyingAmount = commodityBuyingAmount;
      this.headInfo.commodityBuyingTotalAmount = this.$jsTool.sum(
        list.map((d) => d.commodityBuyingTotalAmount)
      );
      this.headInfo.disCountAmount = this.$jsTool.sub(
        this.headInfo.commodityBuyingTotalAmount,
        this.headInfo.commodityBuyingAmount
      );
      this.headInfo.orderAmount = commodityBuyingAmount;
      this.headInfo.totalQuantity = Number(
        this.$jsTool.sumQuantity(list.map((d) => d.itemQuantity))
      );
      this.commoditySelectDialogShow = false;
    },
    changeItemPrice(index, row) {
      let itemAmount = this.$jsTool.multi(row.buyingPrice, row.itemQuantity);
      row = {
        ...row,
        commodityBuyingTotalAmount: itemAmount,
        disCountAmount: 0,
        itemAmount: itemAmount,
      };
      this.$nextTick(() => {
        this.changeItemAfterHandle(index, row);
      });
    },
    changeItemQuantity(index, row, value) {
      if (value == 0) {
        this.$confirm("是否移除所选商品?", "操作提醒", {
          confirmButtonText: "移除",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          closeOnHashChange: false,
        })
          .then(() => {
            this.itemList.splice(index, 1);
            this.$nextTick(() => {
              this.changeItemAfterHandle(index);
            });
          })
          .catch(() => {
            row.itemQuantity = 1;
            this.itemQuantityKey = Math.random();
          });
      } else {
        let itemAmount = this.$jsTool.multi(row.buyingPrice, value);
        row = {
          ...row,
          itemQuantity: value,
          commodityBuyingTotalAmount: itemAmount,
          disCountAmount: 0,
          itemAmount: itemAmount,
        };
        this.$nextTick(() => {
          this.changeItemAfterHandle(index, row);
        });
      }
    },
    changeItemAmount(index, row) {
      if (
        (row.itemAmount || Number(row.itemAmount) == 0) &&
        (row.commodityBuyingTotalAmount ||
          Number(row.commodityBuyingTotalAmount) == 0)
      ) {
        row.disCountAmount = this.$jsTool.sub(
          row.commodityBuyingTotalAmount,
          row.itemAmount
        );
      } else {
        row.disCountAmount = "0.00";
      }
      this.changeItemAfterHandle(index, row);
    },
    changeItemAfterHandle(index, row) {
      if (!row) {
        this.selectCommodity(this.itemList);
        return;
      }
      if (row.commoditySpecId) {
        this.itemList.splice(index, 1, row);
        this.selectCommodity(this.itemList);
      }
    },

    // 收款凭证有关
    collectVoucherFilePreview(index) {
      document.getElementById("collectVoucherImage" + index).click();
    },
    collectVoucherFileDelete(index, file) {
      this.collectVoucherFileList.splice(index, 1);
      this.initCollectVoucherSysFileIdList();
    },
    collectVoucherFileChange(file, fileList) {
      if (file.status == "ready") {
        this.collectVoucherFileList.push({
          ...file,
          url: file.url || URL.createObjectURL(file.raw),
          status: "ready",
        });
      }
      this.initCollectVoucherSysFileIdList();
    },
    collectVoucherFileSuccess(res, file, fileList) {
      let index = this.collectVoucherFileList.findIndex(
        (d) => d.uid == file.uid
      );
      if (res && res.success) {
        this.$message({
          message: "文件上传成功",
          type: "success",
        });
        this.collectVoucherFileList.splice(index, 1, {
          ...this.collectVoucherFileList[index],
          url: res.data.prefix + res.data.name,
          id: res.data.id,
          status: "success",
        });
      } else {
        this.$message({
          message: "文件上传失败",
          type: "error",
        });
        this.collectVoucherFileList.splice(index, 1);
      }
      this.initCollectVoucherSysFileIdList();
    },
    initCollectVoucherSysFileIdList() {
      this.$nextTick(() => {
        this.headInfo.collectVoucherSysFileIdList = this.collectVoucherFileList
          .filter((d) => d.status == "success")
          .map((d) => d.id);
        this.$refs.editOrderFormRef.validateField(
          "collectVoucherSysFileIdList"
        );
      });
    },

    // 纸质单据有关
    paperOrderFilePreview(index) {
      document.getElementById("paperOrderImage" + index).click();
    },
    paperOrderFileDelete(index, file) {
      this.paperOrderFileList.splice(index, 1);
      this.initPaperOrderSysFileIdList();
    },
    paperOrderFileChange(file, fileList) {
      if (file.status == "ready") {
        this.paperOrderFileList.push({
          ...file,
          url: file.url || URL.createObjectURL(file.raw),
          status: "ready",
        });
      }
      this.initPaperOrderSysFileIdList();
    },
    paperOrderFileSuccess(res, file, fileList) {
      let index = this.paperOrderFileList.findIndex((d) => d.uid == file.uid);
      if (res && res.success) {
        this.$message({
          message: "文件上传成功",
          type: "success",
        });
        this.paperOrderFileList.splice(index, 1, {
          ...this.paperOrderFileList[index],
          url: res.data.prefix + res.data.name,
          id: res.data.id,
          status: "success",
        });
      } else {
        this.$message({
          message: "文件上传失败",
          type: "error",
        });
        this.paperOrderFileList.splice(index, 1);
      }
      this.initPaperOrderSysFileIdList();
    },
    initPaperOrderSysFileIdList() {
      this.$nextTick(() => {
        this.headInfo.paperOrderSysFileIdList = this.paperOrderFileList
          .filter((d) => d.status && d.status == "success")
          .map((d) => d.id);
        this.$refs.editOrderFormRef.validateField("paperOrderSysFileIdList");
      });
    },

    // 单据金额
    changeCommodityBuyingAmount() {
      this.headInfo = {
        ...this.headInfo,
        disCountAmount: this.$jsTool.sub(
          this.headInfo.commodityBuyingTotalAmount,
          this.headInfo.commodityBuyingAmount
        ),
      };
      // 先处理销售套装
      // 单据优惠比例，需要扣除套装的固定优惠
      let disCountRadio = this.$jsTool.divis(
        this.headInfo.disCountAmount,
        this.maxCommodityBuyingAmount,
        8
      );
      let disCountAmount = 0;
      this.itemList.forEach((item, index) => {
        if (index == this.itemList.length - 1) {
          disCountAmount = this.$jsTool.sub(
            this.headInfo.disCountAmount,
            this.$jsTool.sum(
              this.itemList
                .filter((d) => d.commoditySpecId != item.commoditySpecId)
                .map((d) => d.disCountAmount)
            )
          );
        } else {
          disCountAmount = this.$jsTool.multi(
            disCountRadio,
            item.commodityBuyingTotalAmount
          );
        }
        this.itemList.splice(index, 1, {
          ...this.itemList[index],
          itemAmount: this.$jsTool.sub(
            item.commodityBuyingTotalAmount,
            disCountAmount
          ),
          disCountAmount: disCountAmount,
        });
      });
      this.selectCommodity(this.itemList);
    },

    async getOrderInfo(args) {
      let res = await this.$api.saleOrder_findVoById(this.orderId, {
        showLoading: true,
        loadingParam: {
          target: "#editDialog > *",
          lock: true,
        },
        ...args,
      });
      if (res && res.success) {
        this.headInfo = {
          ...res.data.headVo,
          collectVoucherSysFileIdList:
            res.data.headVo.collectVoucherImageList.map((d) => d.sysFile.id),
          paperOrderSysFileIdList: res.data.headVo.paperOrderImageList.map(
            (d) => d.sysFile.id
          ),
          collectRemark: res.data.headVo.collectRemark || "",
        };
        this.customer = res.data.headVo.customer;
        this.itemList = res.data.itemList;
        this.collectVoucherFileList =
          res.data.headVo.collectVoucherImageList.map((item) => {
            return {
              imageName: item.sysFile.name,
              id: item.sysFile.id,
              message: "已有图片",
              status: "success",
              thumb: item.sysFile.prefix + item.sysFile.name,
              type: "image",
              url: item.sysFile.prefix + item.sysFile.name,
            };
          });
        this.paperOrderFileList = res.data.headVo.paperOrderImageList.map(
          (item) => {
            return {
              imageName: item.sysFile.name,
              id: item.sysFile.id,
              message: "已有图片",
              status: "success",
              thumb: item.sysFile.prefix + item.sysFile.name,
              type: "image",
              url: item.sysFile.prefix + item.sysFile.name,
            };
          }
        );
        this.$nextTick(() => {
          setTimeout(() => {
            this.$forceUpdate();
          }, 200);
        });
      }
    },

    edit() {
      if (
        this.collectVoucherFileList &&
        this.collectVoucherFileList.length > 0 &&
        this.collectVoucherFileList.filter((d) => d.status == "success")
          .length > 0
      ) {
        this.headInfo.collectVoucherSysFileIdList = this.collectVoucherFileList
          .filter((d) => d.status == "success")
          .map((d) => d.id);
      }
      if (
        this.paperOrderFileList &&
        this.paperOrderFileList.length > 0 &&
        this.paperOrderFileList.filter((d) => d.status == "success").length > 0
      ) {
        this.headInfo.paperOrderSysFileIdList = this.paperOrderFileList
          .filter((d) => d.status == "success")
          .map((d) => d.id);
      }
      this.$refs.editOrderFormRef.validate(async (valid) => {
        if (!valid) {
          return;
        }
        let requestRes = this.headInfo.id
          ? await this.$api.saleOrder_update(
              {
                headUpdatePojo: this.headInfo,
                itemAddNewPojoList: this.itemList,
              },
              {
                showLoading: true,
                loadingParam: {
                  target: "#editDialog > *",
                  lock: true,
                  text: "修改中...",
                },
              }
            )
          : await this.$api.saleOrder_addNew(
              {
                headAddNewPojo: this.headInfo,
                itemAddNewPojoList: this.itemList,
              },
              {
                showLoading: true,
                loadingParam: {
                  target: "#editDialog > *",
                  lock: true,
                  text: "修改中...",
                },
              }
            );
        if (requestRes && requestRes.success) {
          this.close(true);
        }
      });
    },

    close(flush) {
      this.$emit("close", flush);
    },
  },
};
</script>

<style lang="scss" scoped>
.UploadImage {
  float: left;
  width: 100px !important;
  height: 100px !important;
  margin-right: 10px;
  border: 1px dashed var(--fm-border-color);
  border-radius: 5px;
  background-color: var(--fm-border-extralight-color);
  overflow: hidden;
  cursor: pointer;

  &:hover {
    border: 1px dashed var(--fm-primary-color);
  }
}

.UploadImageLoadingIcon {
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.4);
  width: 100px;
  height: 100px;

  &-icon {
    color: white;
    font-size: 18px;
  }
}

.UploadImageHandleIcon {
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.4);
  opacity: 0;
  width: 100px;
  height: 100px;

  &:hover {
    opacity: 1;
  }

  &-icon {
    position: absolute;
    top: 0;
    width: 50px;
    height: 100px;
    color: white;
    font-size: 18px;
  }

  &-previewIcon {
    left: 0;
  }

  &-deleteIcon {
    left: 50px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/SaleOrderEditDialog.vue